import React, {Component} from "react";
import FlexView from "react-flexview";
import {connect} from "react-redux";
import ModalContainer from "../../../modules/commons/ModalContainer";
import SimpleButton from "../../../modules/commons/SimpleButton";
import SimpleModal from "../../../modules/popup/SimpleModal";
import SimpleDataTable from "../../../modules/SimpleDataTable";
import ErrorAction from "../../../Redux/ErrorRedux";
import Api from "../../../Services/Api";
import SimpleLoadingOverlay from "../../../modules/popup/SimpleLoadingOverlay";
import {fetchDataAsync} from "../../../Services/Utils";
import {HttpStatus} from "../../common/Constants";
import { defaultTableChange } from "../../../modules/custom/customTable";

class MasterPenjualanEditAddModal extends Component {
    tableColumns = [
        {
            name: "",
            label: "No",
            options: {
                customBodyRender: (value, tableMeta) => {
                    return <>{tableMeta.rowIndex + 1}</>;
                },
                sort: false,
            },
        },
        {
            name: "userName",
            label: "Username",
        },
        {
            name: "salesName",
            label: "Nama User",
        },
        {
            name: "checked",
            label: "Aksi",
            options: {
                customBodyRender: (val, {rowIndex}) => (
                    <input
                        type="checkbox"
                        checked={val}
                        onChange={() => this.props.handleChecked(rowIndex)}
                    />
                ),
            },
        },
    ];

    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            dataTable: [],
            pagination: {
                page: 1,
                limit: 5,
                totalData: 0,
            },
        };
    }

    componentDidMount = () => {
        // this.setState((prevValue) => ({...prevValue, loading: true}));
        // let response = await fetchDataAsync({
        //     asyncFn: Api.create("NAGAMAS_MASTER_DATA").findSalesNotInSalesTeam,
        //     menuName: "Master Sales",
        //     setError: this.props.setError,
        //     args: this.props.kodeCabang,
        // });
        // if (response.ok && response.data.status === HttpStatus.SUCCESS) {
        //     this.setState((prevValue) => ({
        //         ...prevValue,
        //         dataTable: response.data.data.map((d) => ({...d, checked: false})),
        //     }));
        // }
        // this.setState((prevValue) => ({...prevValue, loading: false}));
    }

    handleSave = async () => {
        const filteredSales = this.props.listSales.filter((d) => d.checked);
        this.props.onAddSales(filteredSales);
    };

    handleChangePage = (tableState) => {
        this.setState((prevValue) => ({
            ...prevValue,
            pagination:{
                ...prevValue.pagination,
                page: tableState.page + 1,
            }
        }));
    };

    handleRowsPerPage = (tableState) => {
        this.setState((prevValue) => ({
            ...prevValue,
            pagination:{
                ...prevValue.pagination,
                page: 1,
                limit: tableState.rowsPerPage,
            }
        }));
    };

    render() {
        const {pagination} = this.state;
        return (
            <>
                <SimpleModal
                    title="Form Data Sales"
                    visible={this.props.visible}
                    onClickClose={this.props.onClickClose}
                    content={
                        <ModalContainer>
                            <SimpleDataTable
                                key={`${pagination.page}-${pagination.limit}-${this.state.dataTable.length}`}
                                data={this.props.listSales}
                                columns={this.tableColumns}
                                toCount={this.props.listSales.length}
                                rowsPerPage={pagination.limit}
                                page={pagination.page - 1}
                                options={{...defaultTableChange(this.handleChangePage, this.handleRowsPerPage), serverSide: false}}
                            />
                            <FlexView hAlignContent="right">
                                <SimpleButton className="margin-top-15px" onClick={this.handleSave}>
                                    Simpan
                                </SimpleButton>
                            </FlexView>
                        </ModalContainer>
                    }
                />
                {this.state.loading && <SimpleLoadingOverlay active={this.state.loading}/>}
            </>
        );
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        setError: (payload) => dispatch(ErrorAction.setError(payload)),
    };
};

export default connect(null, mapDispatchToProps)(MasterPenjualanEditAddModal);
